module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med lulesamisk_sentrert logo_pos(svart).173a335a.png";